/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Style from './Renegociacao25Vantagens.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import WhiteButton from '@/components/atoms/WhiteButton';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';

function Renegociacao25Vantagens() {
  return (
    <>
      <section id="renegociacao25-vantagens">
        <img
          src="assets/renegociacao25/vantagens/santander-symbol.svg"
          alt=""
          className="santander-symbol"
        />
        <ContainerHome24>
          <h2 className="vantagens-titulo desktop">
            Confira as vantagens de renegociar com a Santander Financiamentos
          </h2>
          <h2 className="vantagens-titulo mobile">Vantagens de renegociar no portal Negocie+</h2>
          <div className="vantagens-carrossel">
            <CustomEmblaCarouselHome24
              // loop
              enableBullets
              detectBulletCount
              // hideOverflow
              enableMobileArrows
              enablePrevArrow
              //autoplay={100000}
            >
              {({ className }) => (
                <>
                  <div className={`slide ${className}`}>
                    <img src="assets/renegociacao25/vantagens/ic-facil-rapido.svg" alt="" />
                    <div className="slide-textos">
                      <h4 className="slide-titulo">Fácil e rápido</h4>
                      <p className="slide-texto">
                        Negociação simples, rápida e com ofertas exclusivas.
                      </p>
                    </div>
                  </div>
                  <div className={`slide ${className}`}>
                    <img src="assets/renegociacao25/vantagens/ic-nome-limpo.svg" alt="" />
                    <div className="slide-textos">
                      <h4 className="slide-titulo">Nome limpo</h4>
                      <p className="slide-texto">
                        Nome limpo em até 5 dias após o pagamento do primeiro boleto.
                      </p>
                    </div>
                  </div>
                  <div className={`slide ${className}`}>
                    <img src="assets/renegociacao25/vantagens/ic-mais-prazo.svg" alt="" />
                    <div className="slide-textos">
                      <h4 className="slide-titulo">Mais prazo</h4>
                      <p className="slide-texto">
                        Você pode aumentar o prazo e pagar menos em cada parcela.
                      </p>
                    </div>
                  </div>
                  <div className={`slide ${className}`}>
                    <img src="assets/renegociacao25/vantagens/ic-seguranca.svg" alt="" />
                    <div className="slide-textos">
                      <h4 className="slide-titulo">Segurança</h4>
                      <p className="slide-texto">Faça tudo de casa com a segurança Santander.</p>
                    </div>
                  </div>
                </>
              )}
            </CustomEmblaCarouselHome24>
          </div>
          <WhiteButton
            href="https://santanderfinanciamentos.com.br/portalcliente/login"
            rel="noopener"
            target="_blank"
            className="btn-vantagens-renegociar"
          >
            Quero renegociar
          </WhiteButton>
        </ContainerHome24>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default Renegociacao25Vantagens;
